import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/family-details";

export const Route = createFileRoute("/admin/_admissions/family-details")({
  component: Page,
});
